import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import { DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import { Dialog, DialogFooter, DialogType } from '@fluentui/react/lib/Dialog';
import { _global_buttonStyles, __OBJECT_STRUCTURE_GetList } from '../../../../../common/ObjectStructures/Trasnversal';
import { useBoolean } from '@fluentui/react-hooks';
import List from '../../../../Templates/List';
import ListPagination from "../../../../Templates/List/ListPagination";
import { Col, Row } from 'react-bootstrap';
import { useGetListGapActions } from '../../../../../hooks/services/sKPI/useOfGAP';
import GapActionCard from '../GapActionCard/GapActionCard';
import MessageBox from '../../../../Common/Message/MessageBox';
import { Toggle } from '@fluentui/react';
import { enum__ActionStatus, enum__RevisionStatus, __MessageTypes } from '../../../../../common/Dictionaries';
import { isNullOrEmpty, showMessage } from '../../../../../common/Helpers';
import { updateGapRevisionStatus } from '../../../../../services/sKPI/gap.service';
import CLabel from '../../../../Common/CLabel';


const SidePanelViewAllAction = (props) => {
    const { t } = useTranslation();

    const inputParam_EditMode = props.inputParam_EditMode !== null && props.inputParam_EditMode !== undefined ? props.inputParam_EditMode : false;
    const inputParam_SelectedRevisionStatusId = props.inputParam_SelectedRevisionStatusId !== null && props.inputParam_SelectedRevisionStatusId !== undefined ? props.inputParam_SelectedRevisionStatusId : false;
    const inputParam_GapRevisionsList = props.gapRevisionsList !== null && props.gapRevisionsList !== undefined ? props.gapRevisionsList : null;
    const inputParam_SetGapRevisionsList = props.setGapRevisionsList !== null && props.setGapRevisionsList !== undefined ? props.setGapRevisionsList : null;
    
    const inputParam_GapAnalyzeId = props.inputParam_GapAnalyzeId;
    const inputParam_GapRevisionId = props.inputParam_GapRevisionId;
    const inputParam_IsPanelOpen = props.inputParam_IsPanelOpen;
    const inputParam_SetterIsPanelOpen = props.inputParam_SetterIsPanelOpen;
    
    const [isDialogVisible, { setTrue: showDialog, setFalse: hideDialog }] = useBoolean(false);
    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });
    
    const [hideProcessButton, setHideProcessButton] = useState(false);
    const [actionList, setActionList] = useState(__OBJECT_STRUCTURE_GetList());
    const [actionListFiltred, setActionListFiltred] = useState(null);
    useGetListGapActions(inputParam_GapAnalyzeId, null, inputParam_GapRevisionId, null, null, null, null, actionList, setActionList, inputParam_IsPanelOpen)

    const [tglShowActionsWithProblems, setTglShowActionsWithProblems] = useState(null);

    const onSwitchShowActionsWithProblems = (forceOn = false) => {
        if (!tglShowActionsWithProblems === true) {
            switch (inputParam_SelectedRevisionStatusId) {
                case enum__RevisionStatus.GAP_REVISON_ANALYSIS:
                    setActionListFiltred(prevState => ({
                        ...prevState,
                        fireUpdate:true,
                        data: actionList.data.filter(x => isNullOrEmpty(x.title) ||  isNullOrEmpty(x.action) ||  isNullOrEmpty(x.beginDate) || isNullOrEmpty(x.endDate) || isNullOrEmpty(x.owner) || isNullOrEmpty(x.executor))
                    }))
                    break;
                case enum__RevisionStatus.GAP_REVISION_END:
                    //##Boton togle en este estado esta desactivado.
                    break;
                case enum__RevisionStatus.GAP_REVISION_DIALOGUE:
                    setActionListFiltred(prevState => ({
                        ...prevState,
                        fireUpdate:true,
                        data: actionList.data.filter(x => x.statusId === enum__ActionStatus.GAP_ACTION_COMPLETED)
                    }))
                    break;
                case enum__RevisionStatus.GAP_REVISION_REVISION:
                    //##Boton togle en este estado esta desactivado.
                    break;
                default:
                    break;
            }
        }
        else {
            setActionListFiltred(null)
            setActionList(prevState => ({
                ...prevState,
                fireUpdate:true,
            }))
        }

        setTglShowActionsWithProblems(forceOn? forceOn : !tglShowActionsWithProblems)
    };

    const _onSwitchShowActionsWithProblems = () => {
        onSwitchShowActionsWithProblems()
    };

    const validateForm = () => {
        let isValid = false;
        let newStatusId = inputParam_SelectedRevisionStatusId;
        let messageKeyword = "";

        if (isValid = actionList.data.length > 0) {
            switch (inputParam_SelectedRevisionStatusId) {
                case enum__RevisionStatus.GAP_REVISION:
                    isValid = actionList.data.filter(x => (isNullOrEmpty(x.beginDate) || isNullOrEmpty(x.endDate)) && x.statusId !== enum__ActionStatus.GAP_ACTION_CANCELED).length === 0
                    isValid = isValid ? (inputParam_GapRevisionsList.length > 0) : isValid;
                    if (!isValid) {
                        messageKeyword = 'data-lang-msg-processgap-error-1to2'
                    }
                    else {
                        newStatusId = enum__RevisionStatus.GAP_REVISION_ANALYZE
                    }
                    break;
                case enum__RevisionStatus.GAP_REVISION_ANALYZE:
                    isValid = actionList.data.filter(x => x.statusId !== enum__ActionStatus.GAP_ACTION_COMPLETED && x.statusId !== enum__ActionStatus.GAP_ACTION_ENGAGED && x.statusId !== enum__ActionStatus.GAP_ACTION_PENDING && x.statusId !== enum__ActionStatus.GAP_ACTION_CANCELED).length === 0
                    if (!isValid) {
                        messageKeyword = 'data-lang-msg-processgap-error-2to3'
                    }
                    else {
                        newStatusId = enum__RevisionStatus.GAP_REVISION_DIALOGUE
                    }
                    break;
                case enum__RevisionStatus.GAP_REVISION_DIALOGUE:
                    isValid = actionList.data.filter(x => x.statusId !== enum__ActionStatus.GAP_ACTION_COMPLETED && x.statusId !== enum__ActionStatus.GAP_ACTION_ENGAGED && x.statusId !== enum__ActionStatus.GAP_ACTION_PENDING && x.statusId !== enum__ActionStatus.GAP_ACTION_CANCELED).length === 0
                    if (!isValid) {
                        messageKeyword = 'data-lang-msg-processgap-error-3to4'
                    }
                    else {
                        newStatusId = enum__RevisionStatus.GAP_REVISION_REVISION
                    }
                    break;
                case enum__RevisionStatus.GAP_REVISION_REVISION:
                    isValid = actionList.data.filter(x => x.statusId !== enum__ActionStatus.GAP_ACTION_COMPLETED && x.statusId !== enum__ActionStatus.GAP_ACTION_CANCELED).length === 0
                    if (!isValid) {
                        messageKeyword = 'data-lang-msg-processgap-error-4to5'
                    }
                    else {
                        newStatusId = enum__RevisionStatus.GAP_REVISION_END
                    }
                    break;
                case enum__RevisionStatus.GAP_REVISION_END:
                    isValid = true;
                    newStatusId = enum__RevisionStatus.GAP_REVISION_END
                    break;
                default:
                    newStatusId = inputParam_SelectedRevisionStatusId;
                    break;
            }
        }
        else {
            messageKeyword = 'data-lang-msg-processgap-error-noactions'
        }

        return { isValid, newStatusId, message: messageKeyword };
    };

    const onProcessRevisionClick = () => {
        let isValidForm = validateForm();
        
        if (isValidForm.isValid) {
            updateGapRevisionStatus(inputParam_GapRevisionId, isValidForm.newStatusId).then((response) => {
                if (response.data.succeeded) {
                    inputParam_GapRevisionsList.forEach(revision => {
                        if (revision.id === inputParam_GapRevisionId) {
                            revision.statusId = revision.statusId + 1;
                        }
                    });
                    inputParam_SetGapRevisionsList && inputParam_SetGapRevisionsList(prevState => ({
                        ...prevState,
                        data : inputParam_GapRevisionsList
                    }))
                    setHideProcessButton(true)
                    showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
                }
                else {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                }
            }).catch(() => {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            });
        }
        else {
            onSwitchShowActionsWithProblems(true);
            showMessage(setMessageConfig, true, __MessageTypes.WARNING, t(isValidForm.message))
        }
    };

    const onHideDialog = (ev) => {
        ev.preventDefault();
        hideDialog();
    };

    const onDismissPanel = () => {
        inputParam_SetterIsPanelOpen && inputParam_SetterIsPanelOpen(false)
        setActionListFiltred(null);
        setActionList(__OBJECT_STRUCTURE_GetList());

        window.location.href = window.location.href
    };

    const onHideDialogAndPanel = () => {
        onDismissPanel();
        hideDialog();
    };
    
    const onClosePanel = () => {
        onDismissPanel();
    };

    const onRenderFooterContent = () => {
        return <div>
            {
                inputParam_EditMode && !hideProcessButton &&
                <PrimaryButton onClick={ onProcessRevisionClick } styles={ _global_buttonStyles }>{ t('data-lang-btn-processrevision') }</PrimaryButton>
            }
            <DefaultButton onClick={ onClosePanel }>{ t('data-lang-btn-close') }</DefaultButton>
        </div>
    }

    return (
        <div>
            <Panel
                isOpen={ inputParam_IsPanelOpen }
                isLightDismiss={ true }
                onLightDismissClick={ showDialog }
                onDismiss={ onDismissPanel }
                headerText={ inputParam_EditMode ? t('data-lang-boxname-processrevision') : t('data-lang-boxname-actionlist') }
                closeButtonAriaLabel={ t('data-lang-btn-close') }
                isFooterAtBottom={ true }
                onRenderFooterContent={ onRenderFooterContent }
                customWidth={ PanelType.medium }
                type={ PanelType.medium }
            >    
                {
                    inputParam_EditMode &&
                    <Row>
                        <Col className="pt-3">
                            <CLabel labelText={t('data-lang-lbl-status')} labelValue={t('data-lang-skrevision-status' + inputParam_SelectedRevisionStatusId)} />
                        </Col>
                        <Col>
                            {
                                inputParam_SelectedRevisionStatusId !== enum__RevisionStatus.GAP_REVISION_DIALOGUE &&
                                <Toggle
                                    label={<div>{t('data-lang-btn-showmore')}</div>}
                                    inlineLabel
                                    checked={ tglShowActionsWithProblems !== null ? tglShowActionsWithProblems : false }
                                    onChange={ _onSwitchShowActionsWithProblems }
                                    role="checkbox"
                                    onText={t('data-lang-lbl-actionproblems')}
                                    offText={t("data-lang-lbl-allactions")}
                                    styles={ {root:{ paddingTop: "10px", float: "right", display: "flex"}, label: {marginRight : "5px"}} }
                                />
                            }
                        </Col>
                    </Row>
                }
                {
                    !inputParam_EditMode &&
                    <Row>
                        <Col>
                            <CLabel labelText={t('data-lang-lbl-status')} valueText={t('data-lang-skrevision-status' + inputParam_SelectedRevisionStatusId)} />
                        </Col>
                    </Row>
                }
                <Row>
                    <Col>
                        <List
                            listLocalStoragePageSizeVariableName="viewAllActions"
                            manipulateLocalData={ true }
                            setData={ actionListFiltred === null ? setActionList : setActionListFiltred }
                            data={ actionListFiltred === null ? actionList : actionListFiltred}
                            className="overflow-hidden no-compact-list"
                            columns={[
                                {  
                                    key: 'title',
                                    name: t('data-lang-lbl-data'),
                                    fieldName: 'title',
                                    onRender:(item, row) => {
                                        return <GapActionCard
                                                    inputParam_EditMode={inputParam_EditMode}
                                                    inputParam_GapElementId={'#3'}
                                                    inputParam_ActionItem={item}
                                                    inputParam_ShowSeparatorStyle={false}
                                                    inputParam_SetterActionList={setActionList}
                                                    inputParam_ShowCause={true}
                                                    inputParam_GapAnalyzeId={inputParam_GapAnalyzeId}
                                                    inputParam_GapRevisionId={inputParam_GapRevisionId}
                                                    inputParam_Dflex_Buttons={true}
                                                />
                                    }
                                }  
                            ]}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col className="message-verybottom-panel-medium-pagination" style={{bottom: inputParam_EditMode ? "95px !important" : "60px !important"}}>
                        <ListPagination
                            listLocalStoragePageSizeVariableName="viewAllActions"
                            data={ actionListFiltred === null ? actionList : actionListFiltred }
                            setData={ actionListFiltred === null ? setActionList : setActionListFiltred } />
                    </Col>
                </Row>
                {
                    inputParam_EditMode &&
                    <Row>
                        <Col className='message-verybottom-panel-medium-message' style={{bottom: inputParam_EditMode ? "50px !important" : ""}} >
                            <MessageBox
                                inputParam_Width="96%" 
                                inputParam_Message={ messageConfig.message }
                                inputParam_Display={ messageConfig.showMessage }
                                inputParam_MessageType={ messageConfig.messageType }
                                inputParam_SetterMessage={ setMessageConfig }
                            />
                        </Col>
                    </Row>  
                }
                <Dialog
                    hidden={!isDialogVisible}
                    onDismiss={onHideDialog}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: t('data-lang-msg-close-panel'),
                    }}
                    modalProps={{
                        isBlocking: true,
                        styles: { main: { maxWidth: 450 } },
                    }}
                >
                    <DialogFooter>
                        <PrimaryButton onClick={onHideDialogAndPanel} text={t('data-lang-lbl-yes')} />
                        <DefaultButton onClick={onHideDialog} text={t('data-lang-lbl-no')} />
                    </DialogFooter>
                </Dialog>
            </Panel>
        </div>
    );
};

export default SidePanelViewAllAction;